import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { AttributesModels, AttributesByItemModels } from './AttributesModels';

export const addAttribute = createAsyncThunk(
  'Attributes/addAttribute',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/AddAttribute', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateAttribute = createAsyncThunk(
  'Attributes/updateAttribute',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/UpdateAttribute', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAttributeList = createAsyncThunk(
  'Attributes/getAttributeList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('Inv/GetAttributeList');
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAttributeById = createAsyncThunk(
  'Attributes/getAttributeById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('Inv/GetAttributeById', { params: { id: id } });
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const assignmentAttributes = createAsyncThunk(
  'Attributes/assignmentAttributes',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/AssignmentAttributes', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const assignmentAttributeToMultiItems = createAsyncThunk(
  'Attributes/assignmentAttributeToMultiItems',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/AssignmentAttributeToMultiItems', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const assignmentAttributeToItem = createAsyncThunk(
  'Attributes/assignmentAttributeToItem',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/AssignmentAttributeToItem', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const deleteAssignmentAttribute = createAsyncThunk(
  'Attributes/deleteAssignmentAttribute',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/DeleteAssignmentAttribute', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getItemAttributByItemId = createAsyncThunk(
  'Attributes/getItemAttributByItemId',
  async (ItemId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('Inv/GetItemAttributByItemId', {
        params: { ItemId: ItemId }
      });
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getItemAttributByAttributeId = createAsyncThunk(
  'Attributes/getItemAttributByAttributeId',
  async (AttributeId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('Inv/GetItemAttributByAttributeId', {
        params: { AttributeId: AttributeId }
      });
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  AttributesList: AttributesModels[];
  AttributesById: AttributesModels;
  AttributesByItem: AttributesByItemModels[];
  ItemByAttribute: any[];
  loading: boolean;
  loading2: boolean;
  loadingById: boolean;
  error: any | null;
  error2: any | null;
} = {
  AttributesList: [],
  AttributesById: {} as AttributesModels,
  AttributesByItem: [],
  ItemByAttribute: [],
  loading: false,
  loading2: false,
  loadingById: false,
  error: null,
  error2: null
};

const AttributesSlice = createSlice({
  name: 'Attributes',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getAttributeList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAttributeList.fulfilled, (state, action: PayloadAction<AttributesModels[]>) => {
        state.loading = false;
        state.AttributesList = action.payload;
      })
      .addCase(getAttributeList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getAttributeById.pending, (state, action) => {
        state.loadingById = true;
      })
      .addCase(getAttributeById.fulfilled, (state, action: PayloadAction<AttributesModels>) => {
        state.loadingById = false;
        state.AttributesById = action.payload;
      })
      .addCase(getAttributeById.rejected, (state, action: PayloadAction<any>) => {
        state.loadingById = false;
        state.error = action.payload;
      })
      //~~~~~~~~~~~~~~
      .addCase(getItemAttributByItemId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        getItemAttributByItemId.fulfilled,
        (state, action: PayloadAction<AttributesByItemModels[]>) => {
          state.loading = false;
          state.AttributesByItem = action.payload;
        }
      )
      .addCase(getItemAttributByItemId.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //~~~~~~~~~~~~~~
      .addCase(getItemAttributByAttributeId.pending, (state, action) => {
        state.error2 = null;
        state.loading2 = true;
      })
      .addCase(
        getItemAttributByAttributeId.fulfilled,
        (state, action: PayloadAction<AttributesByItemModels[]>) => {
          state.loading2 = false;
          state.ItemByAttribute = action.payload;
        }
      )
      .addCase(getItemAttributByAttributeId.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      });
  }
});

export default AttributesSlice.reducer;
